export enum ADDITIONAL_PARAMETERS {
  TIME_QUANTITY = 'TimeQuantity',
  PUMP_SIZE_CODE = 'PumpSizeCode',
  MAX_LENGTH = 'MaxLength',
  MIN_LENGTH = 'MinLength',
  TYPE = 'Type',
  PUMP_TYPE = 'PumpType',
  TIME_PER_LOAD_IN_MINUTES = 'TimePerLoadInMinutes',
  INSTALLATION_TIME = 'InstallationTime',
  RMS_UNLOAD_TYPE_CODE = 'RMSUnloadCode',
  PUMP_ID = 'pumpId',
  ELEMENT_SAP_CODE = 'ElementSAPCode',
}
